// StaffDetailTable.jsx
import React from 'react';

const StaffDetailTable = ({ data, kgNumber, onBack, loading }) => {

  if (loading) {
    return (
      <div className="staff-table-container">
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Завантаження даних...</span>
          </div>
          <p className="text-muted mt-2">Завантаження деталей...</p>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="staff-table-container">
        <div className="back-button-section">
          <button className="btn btn-back-to-aggregated" onClick={onBack}>
            <span className="back-arrow">←</span>
            Повернутись до списку садочків
          </button>
        </div>
        <div className="text-center py-5 text-muted">
          Не має інформації про працівників для садочка №{kgNumber}
        </div>
      </div>
    );
  }

  return (
    <div className="staff-table-container">
      <div className="back-button-section">
        <button className="btn btn-back-to-aggregated" onClick={onBack}>
          <span className="back-arrow">←</span>
          Повернутись до списку садочків
        </button>
      </div>

      <div className="table-header mb-3">
        <h5>
          Детальна інформація щодо працівників в ЗДО №{kgNumber} станом на {new Date().toLocaleDateString('uk-UK')}
        </h5>
      </div>
      
      <div className="table-responsive">
        <table className="table align-middle staff-table" style={{ fontSize: '14px' }}>
          <thead>
            <tr>
              <th style={{ width: '5%' }}>№</th>
              <th style={{ width: '35%' }}>Посада</th>
              <th style={{ width: '15%' }}>Тип посади</th>
              <th style={{ width: '8%' }}>Жінок</th>
              <th style={{ width: '8%' }}>Чоловіків</th>
              <th style={{ width: '10%' }}>Всього працівників</th>
              <th style={{ width: '10%' }}>Штатних одиниць</th>
              <th style={{ width: '8%' }}>Зайнято</th>
              <th style={{ width: '8%' }}>Вакансій</th>
            </tr>
          </thead>
          <tbody>
            {data.map((position, index) => (
              <tr key={position.positionId || index} className={index % 2 === 0 ? '' : 'staff-table-even'}>
                <td>{index + 1}</td>
                <td>{position.positionName}</td>
                <td>{position.positionType}</td>
                <td>{position.femaleCount || 0}</td>
                <td>{position.maleCount || 0}</td>
                <td>{position.totalEmployees || 0}</td>
                <td>{position.totalUnits || 0}</td>
                <td>{position.occupiedUnits || 0}</td>
                <td className={position.vacantUnits > 0 ? 'staff-vacant-highlight' : ''}>
                  {position.vacantUnits || 0}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffDetailTable;